/*--------------------------------------------------------------------------*
 * 市区町村パネル取得
 *--------------------------------------------------------------------------*/
module Module_PrefAjax {
	enum Mode {
		Pc = "pc",
		Sp = "sp"
	}

	export class Model_PrefAjax {
		makePanel(pref_id: string, mode: Mode): JQueryXHR {
			return $.ajax({
				url: '/mechanic/api/get_city_panel.php',
				type: 'get',
				dataType: 'html',
				data: { mode: mode, prefecture_id: pref_id },
				timeout: 10000
			});
		}
	}
}
